function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodNoMealFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.974 28.204L29.31 3.868l1.325 1.326L6.3 29.529l-1.326-1.325z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.31 2.05c-.168-.057-1.68-.497-3.377.734-1.927 1.398-3.243 4.321-3.937 8.727l2.6-2.6c.756-2.693 1.728-3.908 2.444-4.456.357-.274.69-.411.96-.475v1.528l2-2V3a1 1 0 00-.69-.95zM27 11.542l-2 2V30h2V11.542zM18.416 20.125l2.029-2.028c-.01.363-.018.734-.023 1.116h2.59v2h-3.596a1 1 0 01-1-1v-.088zM9.124 29.418l2-2V30h-2v-.582zM11.124 19.383v-4.742c2.901-.48 5.123-3 5.123-6.034V2h-2v6.607a4.128 4.128 0 01-4.123 4.123A4.128 4.128 0 016 8.607V2H4v6.607c0 3.035 2.222 5.555 5.124 6.034v6.742l2-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.416 9.76a1 1 0 11-2 0V2h2v7.76zM12.832 9.76a1 1 0 11-2 0V2h2v7.76z",
    fill: props.color
  }));
}

export default SvgIconFoodNoMealFilled;